// src/sysconfig.js

let _config = null;
let _configPromise = null;

export function inferDbamBase() {
  const origin = (typeof window !== "undefined" && window.location && window.location.origin) || "";
  if (origin && origin.includes("cloudsam-designer")) {
    return origin.replace("cloudsam-designer", "sam-dbam");
  }
  if (origin && origin.includes("cloudsam-console")) {
    return origin.replace("cloudsam-console", "sam-dbam");
  }
  return "http://localhost:8080";
}

export async function getSysconfig() {
  if (_config) return _config;
  if (_configPromise) return _configPromise;

  _configPromise = (async () => {
    // Use REACT_APP_SAM_DBAM_URL which is baked into the build from .env
    const envBase = process.env.REACT_APP_SAM_DBAM_URL;
    const dbamBase = envBase || inferDbamBase();
    const url = `${dbamBase.replace(/\/+$/, "")}/dbam/v1/config`;

    const res = await window.fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch sysconfig: ${res.status} ${res.statusText}`);
    }

    const json = await res.json();
    _config = json;
    return _config;
  })();

  try {
    return await _configPromise;
  } finally {
    _configPromise = null;
  }
}

export async function getServiceUrl(name) {
  const config = await getSysconfig();
  return config?.data?.services?.[name];
}

// getFeatureFlag resolves a server-side feature flag (config.data.features[name]).
// Returns false when the flag is absent or the config fetch fails, so callers gate
// closed by default — matching the server's default-OFF archiver flags.
export async function getFeatureFlag(name) {
  try {
    const config = await getSysconfig();
    return config?.data?.features?.[name] === true;
  } catch (_) {
    return false;
  }
}
